import ExamChecklist from './components/ExamChecklist'

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4 py-8">
        <header className="text-center mb-8">
          <h1 className="text-4xl font-bold text-indigo-900">
            Générateur d'Horaires d'Examens
          </h1>
          <p className="text-gray-600 mt-2">
            Système de gestion et planification des examens
          </p>
        </header>

        <ExamChecklist />
      </div>
    </div>
  )
}

export default App
